//@ts-nocheck
import * as React from 'react';

import { ListStyleType, someList, toggleList } from '@platejs/list';
import { useIndentTodoToolBarButton, useIndentTodoToolBarButtonState } from '@platejs/list/react';
import { List, ListOrdered, ListTodoIcon, Undo2Icon } from 'lucide-react';
import { useEditorRef, useEditorSelector } from 'platejs/react';

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from 'src/components/ui/editor/ui/dropdown-menu';

import {
  ToolbarEditorButton,
  ToolbarEditorButtonWithoutTooltip,
  ToolbarEditorSplitButton,
  ToolbarEditorSplitButtonPrimary,
  ToolbarEditorSplitButtonSecondary,
} from './toolbar-editor';

export function BulletedListToolbarButton() {
  const editor = useEditorRef();
  const [open, setOpen] = React.useState(false);

  const pressed = useEditorSelector(
    (editor) => someList(editor, [ListStyleType.Disc, ListStyleType.Circle, ListStyleType.Square]),
    [],
  );

  return (
    <ToolbarEditorButton
      className="data-[state=on]:bg-accent data-[state=on]:text-accent-foreground"
      onClick={() => {
        toggleList(editor, {
          listStyleType: ListStyleType.Disc,
        });
      }}
      onMouseDown={(e) => e.preventDefault()}
      tooltip="Numbered List"
      data-state={pressed ? 'on' : 'off'}
    >
      <List className="size-4" />
    </ToolbarEditorButton>

    // <ToolbarEditorSplitButton pressed={open}>
    //   <ToolbarEditorButtonWithoutTooltip
    //     className="data-[state=on]:bg-accent data-[state=on]:text-accent-foreground"
    //     onClick={() => {
    //       toggleList(editor, {
    //         listStyleType: ListStyleType.Disc,
    //       });
    //     }}
    //     data-state={pressed ? 'on' : 'off'}
    //   >
    //     <List className="size-4" />
    //   </ToolbarEditorButtonWithoutTooltip>
    // </ToolbarEditorSplitButton>
  );
}

export function NumberedListToolbarButton() {
  const editor = useEditorRef();
  const [open, setOpen] = React.useState(false);

  const pressed = useEditorSelector(
    (editor) =>
      someList(editor, [
        ListStyleType.Decimal,
        ListStyleType.LowerAlpha,
        ListStyleType.UpperAlpha,
        ListStyleType.LowerRoman,
        ListStyleType.UpperRoman,
      ]),
    [],
  );

  return (
    <ToolbarEditorButton
      className="data-[state=on]:bg-accent data-[state=on]:text-accent-foreground"
      onClick={() =>
        toggleList(editor, {
          listStyleType: ListStyleType.Decimal,
        })
      }
      onMouseDown={(e) => e.preventDefault()}
      tooltip="Numbered List"
      data-state={pressed ? 'on' : 'off'}
    >
      <ListOrdered className="size-4" />
    </ToolbarEditorButton>
  );
}

export function TodoListToolbarButton(props: React.ComponentProps<typeof ToolbarEditorButton>) {
  const state = useIndentTodoToolBarButtonState({ nodeType: 'todo' });
  const { props: buttonProps } = useIndentTodoToolBarButton(state);

  return (
    <ToolbarEditorButton {...props} {...buttonProps} tooltip="Todo">
      <ListTodoIcon />
    </ToolbarEditorButton>
  );
}
